import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-body pt-0 pr-0"
}
const _hoisted_2 = { class: "card bg-secondary" }
const _hoisted_3 = { class: "card-body d-flex justify-content-center align-items-center" }
const _hoisted_4 = {
  class: "bg-light position-absolute row d-flex justify-content-between align-items-center w-100 p-3",
  style: {"top":"0"}
}
const _hoisted_5 = {
  key: 0,
  class: "h6"
}
const _hoisted_6 = { class: "card-pag" }
const _hoisted_7 = {
  class: "d-flex align-items-center justify-content-between",
  style: {"gap":"10px"}
}
const _hoisted_8 = { class: "flex flex-center" }
const _hoisted_9 = { class: "row w-100 pt-5 tw-pdfView" }
const _hoisted_10 = {
  key: 1,
  class: "card-body pt-0 pr-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_facebook = _resolveComponent("q-spinner-facebook")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_VuePDF = _resolveComponent("VuePDF")!

  return (_ctx.templateSelected)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                (_ctx.myPDF)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.previewTemplate), 1))
                  : _createCommentVNode("", true),
                (_ctx.myPDF)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      class: "btn btn-outline-primary d-none",
                      icon: "download",
                      loading: _ctx.isLoadingDownload,
                      onClick: _ctx.onDownloadEvent
                    }, {
                      loading: _withCtx(() => [
                        _createVNode(_component_q_spinner_facebook)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("task.buttons.download_document")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      class: "btn btn-outline-primary",
                      icon: "arrow_back_ios",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousPage()))
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.pageNav) + "-" + _toDisplayString(this.myPDF.pages), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      class: "btn btn-outline-primary",
                      icon: "arrow_forward_ios",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage()))
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createBlock(_component_VuePDF, {
                pdf: _ctx.myPDF.pdf,
                page: _ctx.pageNav,
                fitParent: "true",
                key: _ctx.myPDF
              }, null, 8, ["pdf", "page"]))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "card bg-secondary" }, [
          _createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center" }, [
            _createElementVNode("span", {
              style: {"font-size":"122px","padding":"3rem","color":"#ffffff"},
              class: "material-icons"
            }, " description ")
          ])
        ], -1)
      ]))]))
}